import styled from "styled-components";

export const Wrapper = styled.div`

  --billing-soft-surface: var(--app-surface-alt);
  --billing-soft-border: var(--app-border);
  --billing-elevated-shadow: 0 10px 24px rgba(17, 24, 39, 0.05);
  --billing-overlay-bg: rgba(243, 244, 246, 0.82);
  --billing-scroll-track: var(--app-surface-alt);
  --billing-scroll-thumb: #c0c6d4;
  --billing-success-soft-bg: rgba(34, 197, 94, 0.1);
  --billing-success-soft-border: rgba(34, 197, 94, 0.28);
  --billing-danger-soft-bg: rgba(244, 91, 104, 0.1);
  --billing-danger-soft-border: rgba(244, 91, 104, 0.32);

  [data-bs-theme="dark"] & {
    --billing-soft-surface: #23263a;
    --billing-soft-border: #3a3f58;
    --billing-elevated-shadow: 0 14px 30px rgba(0, 0, 0, 0.35);
    --billing-overlay-bg: rgba(22, 26, 40, 0.84);
    --billing-scroll-track: #23263a;
    --billing-scroll-thumb: #4a516c;
  }

.billing-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 0px 18px;
  }

  .billing-title {
    font-size: 22px;
    font-weight: 800;
    color: var(--app-text);
    letter-spacing: -0.02em;
  }

  .billing-subtitle {
    margin-top: 4px;
    font-size: 13px;
    color: var(--app-text-muted);
  }

  .billing-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    border-radius: 999px;
    background: color-mix(in srgb, var(--app-surface) 78%, transparent);
    backdrop-filter: blur(6px);
    border: 1px solid var(--billing-soft-border);
    box-shadow: 0 6px 18px rgba(17, 24, 39, 0.06);
    white-space: nowrap;
  }
  .billing-status__icon {
    font-size: 16px;
  }
  .billing-status-icon {
    font-size: 18px;
    display: flex;
  }
  .billing-status__icon i[data-active="true"] {
    color: #54b948;
  }
  .billing-status__icon i[data-active="false"] {
    color: #ff4747;
  }
  .billing-status__text {
    color: var(--app-text);
    font-size: 13px;
  }
  .billing-status__dot {
    opacity: 0.6;
    margin: 0 6px;
  }

  .billing-card {
    border-radius: 14px;
    overflow: hidden;
  }

  .billing-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .billing-section-title {
    font-size: 17px;
    font-weight: 800;
    color: var(--app-text);
  }
  .billing-section-subtitle {
    margin-top: 2px;
    font-size: 13px;
    color: var(--app-text-muted);
  }

  .billing-btn {
    // border-radius: 10px;
    font-weight: 600;
    font-size: 13px;
        min-height: 35px !important;
  }

  .billing-link.ant-btn-link {
    padding: 0;
    height: auto;
    font-weight: 700;
    color: #f45b68;
  }
  .billing-method-tag {
    border-radius: 20px;
  }
  .billing-link-disabled {
    color: var(--app-text-muted) !important;
    opacity: 0.75;
  }

  .billing-tag {
    border-radius: 999px;
    font-weight: 700;
    background: var(--billing-danger-soft-bg);
    border-color: var(--billing-danger-soft-border);
    color: #f45b68;
  }

  .billing-amount {
    font-weight: 800;
    color: var(--app-text);
  }

  .billing-plan__coupon {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    flex-shrink: 0;
  }

  .billing-plan__coupon--applied {
    justify-content: space-between;
    padding: 8px 10px;
    border-radius: 10px;
    border: 1px solid var(--billing-success-soft-border);
    background: var(--billing-success-soft-bg);
  }

  .billing-plan__coupon-applied {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }

  .billing-plan__coupon-applied-icon {
    color: #16a34a;
    font-size: 14px;
    flex-shrink: 0;
  }

  .billing-plan__coupon-applied-code {
    font-size: 12px;
    font-weight: 800;
    color: #16a34a;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .billing-plan__coupon-applied-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--app-text-muted);
  }

  .billing-plan__coupon-remove {
    border: 0;
    background: transparent;
    padding: 0;
    font-size: 11px;
    font-weight: 700;
    color: var(--app-text-muted);
    cursor: pointer;
    flex-shrink: 0;
  }

  .billing-plan__coupon-remove:hover:not(:disabled) {
    color: #f45b68;
  }

  .billing-plan__coupon-remove:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .billing-plan__coupon-input.ant-input-affix-wrapper,
  .billing-plan__coupon-input.ant-input {
    flex: 1;
    min-width: 0;
    height: 32px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .billing-plan__coupon-input.ant-input-affix-wrapper {
    padding-top: 0;
    padding-bottom: 0;
    align-items: center;
  }

  .billing-plan__coupon-input.ant-input-affix-wrapper > input.ant-input {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .billing-plan__coupon-apply.ant-btn {
    height: 32px !important;
    min-height: 32px !important;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    padding: 0 12px;
    flex-shrink: 0;
  }

  .billing-period {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
  .billing-period__label {
    font-size: 13px;
    color: var(--app-text-muted);
    font-weight: 700;
  }
  .billing-period__toggle {
    display: inline-flex;
    background: var(--billing-soft-surface);
    border-radius: 999px;
    padding: 3px;
    border: 1px solid var(--billing-soft-border);
  }
  .billing-pill {
    border: 0;
    background: transparent;
    border-radius: 999px;
    padding: 6px 10px;
    font-size: 13px;
    font-weight: 800;
    color: var(--app-text-muted);
    cursor: pointer;
  }
  .billing-pill.is-active {
    background: var(--app-surface);
    color: var(--app-text);
    box-shadow: 0 6px 14px rgba(17, 24, 39, 0.08);
  }

  .billing-plans-grid {
    // display: grid;
    // grid-template-columns: 1.05fr 1fr;
    // gap: 18px;
  }

  .billing-current {
    border: 1px solid var(--billing-soft-border);
    border-radius: 14px;
    background: linear-gradient(
      180deg,
      color-mix(in srgb, var(--app-surface) 96%, #f45b68 4%) 0%,
      color-mix(in srgb, var(--app-surface) 90%, #f45b68 10%) 100%
    );
    padding: 25px;
    box-shadow: var(--billing-elevated-shadow);
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    min-height:550px;
  }

  .billing-current__badge {
    display: inline-flex;
    align-self: flex-start;
    padding: 6px 10px;
    border-radius: 999px;
    background: var(--billing-danger-soft-bg);
    color: var(--app-text);
    font-size: 13px;
    font-weight: 900;
  }
  .billing-current__name {
    margin-top: 10px;
    font-size: 18px;
    font-weight: 900;
    color: var(--app-text);
  }
  .billing-current__price {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 900;
    color: var(--app-text);
  }
  .billing-current__price span {
    font-weight: 700;
    color: var(--app-text-muted);
    margin-left: 4px;
    font-size: 13px;
  }
  .billing-current__desc {
    margin-top: 6px;
    font-size: 13px;
    color: var(--app-text-muted);
    font-weight: 600;
    margin-bottom: 10px;
  }
  .billing-current__actions {
    margin-top: 12px;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .billing-hint {
    margin-top: 10px;
    font-size: 13px;
    color: var(--app-text-muted);
    line-height: 1.5;
  }

  .billing-available {
    border: 1px solid var(--billing-soft-border);
    border-radius: 14px;
    background: var(--app-surface);
    padding: 14px 14px 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .billing-available__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
  }
  .billing-available__title {
    font-size: 15px;
    font-weight: 900;
    color: var(--app-text);
  }
  .billing-available__nav {
    display: inline-flex;
    gap: 8px;
  }
  .billing-icon-btn.ant-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-color: var(--billing-soft-border);
  }

  .billing-scroll {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(330px, 1fr);
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 10px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    align-items: stretch;
  }
  .billing-scroll::-webkit-scrollbar {
    height: 10px;
  }
  .billing-scroll::-webkit-scrollbar-track {
    background: var(--billing-scroll-track);
    border-radius: 999px;
  }
  .billing-scroll::-webkit-scrollbar-thumb {
    background: var(--billing-scroll-thumb);
    border-radius: 999px;
  }

  .billing-plan {
    scroll-snap-align: start;
    border: 1px solid var(--billing-soft-border);
    border-radius: 14px;
    padding: 14px;
    background: var(--app-surface);
    box-shadow: 0 10px 18px rgba(17, 24, 39, 0.04);
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    height: 100%;
  }
  .billing-plan.is-highlighted {
    border-color: rgba(244, 91, 104, 0.35);
    box-shadow: 0 16px 28px rgba(244, 91, 104, 0.12);
  }
  .billing-plan__name {
    font-size: 15px;
    font-weight: 900;
    color: #ff4d4f;
  }
  .billing-save-badge {
    background: #e8f5e9;
    color: #2e7d32;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 20px;
    white-space: nowrap;
  }
  .billing-billed-annually {
    display: block;
    font-size: 11px;
    color: var(--app-text-muted);
    margin-top: 4px;
    font-weight: 400;
    letter-spacing: 0.1px;
  }
  .billing-plan__price {
    margin-top: 6px;
    display: flex;
    align-items: baseline;
    gap: 6px;
    flex-wrap: wrap;
  }
  .billing-plan__priceValue {
    font-size: 20px;
    font-weight: 950;
    color: var(--app-text);
  }
  .billing-plan__priceUnit {
    font-size: 13px;
    font-weight: 700;
    color: var(--app-text-muted);
  }
  .billing-plan__perks {
    margin: 10px 0 12px;
    padding: 0;
    list-style: none;
    display: grid;
    gap: 8px;
    color: var(--app-text-muted);
    font-size: 13px;
    font-weight: 600;
    align-content: start;
  }
  /* Only expand perks inside available-plan cards to push CTA to the bottom */
  .billing-plan .billing-plan__perks {
    flex: 1;
  }
  .billing-plan__perks li {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }
  .billing-check {
    width: 16px;
    height: 16px;
    border-radius: 999px;
    background: rgba(34, 197, 94, 0.14);
    border: 1px solid rgba(34, 197, 94, 0.3);
    position: relative;
    margin-top: 1px;
    flex: 0 0 16px;
  }
  .billing-check:after {
    content: "";
    position: absolute;
    inset: 4px 5px 5px 4px;
    border-right: 2px solid #16a34a;
    border-bottom: 2px solid #16a34a;
    transform: rotate(40deg);
  }
  .billing-plan__cta {
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    margin-top: auto;
    flex-shrink: 0;
    height: 36px;
  }

  .billing-plan__cta--enterprise.ant-btn {
    border-color: #ff4d4f;
    color: #ff4d4f;
    font-weight: 700;
  }
  .billing-plan__cta--enterprise.ant-btn:hover {
    background: var(--billing-soft-surface);
    border-color: #f45b68;
    color: #f45b68;
  }

  .billing-plan__custom-pricing {
    font-size: 20px;
    font-weight: 950;
    letter-spacing: -0.02em;
  }

  /* ── Disabled plan overlay ─────────────────────────────────────── */
  .billing-plan__disabled-overlay {
    position: absolute;
    inset: 0;
    background: var(--billing-overlay-bg);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    border-radius: 14px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    opacity: 0;
    transition: opacity 0.22s ease;
  }
  .billing-plan:hover .billing-plan__disabled-overlay {
    opacity: 1;
  }
  .billing-plan__disabled-overlay-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .billing-plan__disabled-overlay-icon {
    font-size: 28px;
    color: #f45b68;
    line-height: 1;
  }
  .billing-plan__disabled-overlay-title {
    font-size: 13px;
    font-weight: 900;
    color: var(--app-text);
    letter-spacing: -0.01em;
  }
  .billing-plan__disabled-overlay-text {
    font-size: 11.5px;
    font-weight: 500;
    color: var(--app-text-muted);
    line-height: 1.6;
    max-width: 220px;
  }

  /* ── Order limit badge ─────────────────────────────────────────── */
  .billing-plan__order-limit {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: var(--billing-success-soft-bg);
    border: 1px solid var(--billing-success-soft-border);
    border-radius: 10px;
    padding: 8px 10px;
    margin-bottom: 10px;
  }
  .billing-plan__order-limit.is-exceeded {
    background: var(--billing-danger-soft-bg);
    border-color: var(--billing-danger-soft-border);
  }
  .billing-plan__order-limit-icon {
    font-size: 15px;
    color: #16a34a;
    margin-top: 1px;
    flex-shrink: 0;
    line-height: 1.4;
        height: 35px;
    /* border: 1px solid red; */
    width: 35px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 23px !important;
    background: var(--billing-success-soft-bg);
  }
  
  .billing-plan__order-limit-icon i{
    font-size:17px
  }

  .billing-plan__order-limit.is-exceeded .billing-plan__order-limit-icon {
    color: #f45b68;
    background: var(--billing-danger-soft-bg);
  }
  .billing-plan__order-limit-main {
    font-size: 13px;
    font-weight: 700;
    color: var(--app-text);
  }
  .billing-plan__order-limit.is-exceeded .billing-plan__order-limit-main {
    color: #f45b68;
  }
  .billing-plan__order-limit-sub {
    font-size: 13px;
    font-weight: 600;
    color: var(--app-text-muted);
    margin-top: 2px;
  }
  .billing-plan__order-limit.is-exceeded .billing-plan__order-limit-sub {
    color: #f45b68;
  }

  .billing-whatsapp-row {
    margin-bottom: 24px;
  }
  .billing-whatsapp-icon {
    font-size: 20px;
    color: #128c7e;
  }
  .billing-whatsapp-title {
    margin-bottom: 4px;
  }
  .billing-small-tag {
    font-size: 11px;
  }
  .billing-unlimited-tag {
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 20px;
  }
  .billing-whatsapp-usage-value {
    font-size: 24px;
    font-weight: 700;
    color: var(--app-text);
  }
  .billing-whatsapp-usage-max {
    font-size: 14px;
    color: var(--app-text-muted);
    margin-left: 4px;
  }
  .billing-whatsapp-usage-pct {
    font-size: 14px;
    font-weight: 500;
  }

  .billing-modal-title-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .billing-modal-title-icon {
    color: #faad14;
    font-size: 20px;
    flex-shrink: 0;
  }
  .billing-monthly-confirm-modal .billing-modal-title-icon {
    font-size: 22px;
  }
  .billing-modal-title-text {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: var(--app-text);
  }
  .billing-modal-body-text {
    font-family: "Inter", sans-serif;
    font-size: 13px;
    line-height: 1.7;
    color: var(--app-text);
  }
  .billing-modal-ok-text {
    font-family: "Inter", sans-serif;
    font-weight: 500;
  }
  .billing-modal-cancel-text {
    font-family: "Inter", sans-serif;
  }
  .billing-switch-annual-btn {
    border-color: #16a34a !important;
    color: #16a34a !important;
    font-weight: 600;
  }

  .billing-cancel-modal-content {
    padding-top: 8px;
  }
  .billing-cancel-modal-desc {
    font-family: "Inter", sans-serif;
    font-size: 13px;
    color: var(--app-text-muted);
    margin-bottom: 16px;
  }
  .billing-cancel-modal-section {
    margin-bottom: 20px;
  }
  .billing-cancel-modal-label {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 13px;
    margin-bottom: 8px;
    color: var(--app-text);
  }
  .billing-cancel-modal-required {
    color: #f45b68;
  }
  .billing-cancel-modal-optional {
    font-weight: 400;
    color: var(--app-text-muted);
  }
  .billing-cancel-modal-radio-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .billing-cancel-modal-radio {
    font-family: "Inter", sans-serif;
    font-size: 13px;
  }
  .billing-cancel-modal-textarea {
    font-family: "Inter", sans-serif;
    font-size: 13px;
  }
  .billing-invoice-header-row {
    color: var(--app-text) !important;
  }
  .billing-invoice-mobile-card {
    border-radius: 8px;
    background: var(--app-surface);
    border: 1px solid var(--billing-soft-border);
  }
  .billing-fallback-card-icon {
    font-size: 28px;
    color: #f45b68;
  }

  [data-bs-theme="dark"] & .billing-save-badge {
    background: #25352f;
    color: #6ee7a8;
  }
  [data-bs-theme="dark"] & .billing-whatsapp-icon {
    color: #25d366;
  }
  [data-bs-theme="dark"] & .billing-switch-annual-btn {
    border-color: #22c55e !important;
    color: #86efac !important;
    background: #1f2e26 !important;
  }
  [data-bs-theme="dark"] & .billing-status {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
  }
  [data-bs-theme="dark"] & .billing-check {
    background: rgba(34, 197, 94, 0.18);
    border-color: rgba(34, 197, 94, 0.35);
  }

  /* ── Full-page loader before payment gateway opens ─────────────── */
  .billing-gateway-loader {
    position: fixed;
    inset: 0;
    background: rgba(17, 24, 39, 0.55);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .billing-gateway-loader__content {
    background: var(--app-surface);
    border-radius: 20px;
    padding: 44px 52px;
    box-shadow: 0 24px 60px color-mix(in srgb, #111827 45%, transparent);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    min-width: 280px;
    text-align: center;
  }
  .billing-gateway-loader__title {
    font-size: 15px;
    font-weight: 800;
    color: var(--app-text);
  }
  .billing-gateway-loader__subtitle {
    font-size: 13px;
    font-weight: 500;
    color: var(--app-text-muted);
    line-height: 1.5;
  }

  .billing-payments-grid {
    display: grid;
    grid-template-columns: 1.4fr 0.9fr;
    gap: 14px;
  }

  .billing-payCard {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 14px;
    border-radius: 14px;
    border: 1px solid var(--billing-soft-border);
    background: var(--app-surface);
  }
  .billing-payCard.is-default {
    background: linear-gradient(
      180deg,
      color-mix(in srgb, var(--app-surface) 95%, #f45b68 5%) 0%,
      color-mix(in srgb, var(--app-surface) 88%, #f45b68 12%) 100%
    );
    border-color: var(--billing-danger-soft-border);
  }
  .billing-payCard__left {
    display: flex;
    gap: 14px;
    min-width: 0;
    align-items: center;
  }
  .billing-payCard__brand {
    width: 56px;
    height: 38px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 900;
    background: var(--billing-soft-surface);
    color: var(--app-text);
    flex: 0 0 56px;
    font-size: 13px;
  }
  .billing-payCard__meta {
    min-width: 0;
  }
  .billing-payCard__number {
    font-size: 13px;
    font-weight: 900;
    color: var(--app-text);
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
  }
  .billing-defaultTag {
    display: inline-flex;
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 900;
    background: var(--billing-success-soft-bg);
    border: 1px solid var(--billing-success-soft-border);
    color: #16a34a;
  }
  .billing-payCard__name {
    margin-top: 4px;
    font-size: 13px;
    font-weight: 600;
    color: var(--app-text-muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 560px;
  }
  .billing-payCard__actions {
    display: inline-flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .billing-billingInfo {
    border-radius: 14px;
    border: 1px solid var(--billing-soft-border);
    background: linear-gradient(
      180deg,
      color-mix(in srgb, var(--app-surface) 95%, #f45b68 5%) 0%,
      color-mix(in srgb, var(--app-surface) 90%, #f45b68 10%) 100%
    );
    padding: 14px;
    height: 100%;
  }
  .billing-billingInfo__title {
    font-size: 13px;
    font-weight: 900;
    color: var(--app-text);
    margin-bottom: 10px;
  }
  .billing-billingInfo__row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px dashed var(--billing-soft-border);
  }
  .billing-billingInfo__row:last-of-type {
    border-bottom: 0;
    margin-bottom: 10px;
  }
  .billing-billingInfo__label {
    font-size: 13px;
    color: var(--app-text-muted);
    font-weight: 700;
  }
  .billing-billingInfo__value {
    font-size: 13px;
    color: var(--app-text);
    font-weight: 900;
    text-align: right;
  }

  @media (max-width: 1200px) {
    .billing-plans-grid {
      grid-template-columns: 1fr;
    }
    .billing-payments-grid {
      grid-template-columns: 1fr;
    }
    .billing-header {
      flex-direction: column;
      align-items: flex-start;
    }
    .billing-card__header {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  @media (max-width: 768px) {
    .billing-plan__coupon {
      flex-wrap: wrap;
    }

    .billing-plan__coupon-apply.ant-btn {
      width: 100%;
    }
  }
`;
